import { createContext, useContext, useState, useCallback } from "react";
import { scrollToId } from "../lib/scroll";

const BookingContext = createContext(null);

export const BookingProvider = ({ children }) => {
  const [selection, setSelection] = useState({ pkg: "", eventType: "", nonce: 0 });
  const [tab, setTab] = useState("wedding");
  const book = useCallback((pkg, eventType) => {
    setSelection((s) => ({ pkg, eventType, nonce: s.nonce + 1 }));
    scrollToId("contact");
  }, []);
  const openTab = useCallback((id) => {
    setTab(id);
    scrollToId("packages");
  }, []);
  return <BookingContext.Provider value={{ selection, book, tab, setTab, openTab }}>{children}</BookingContext.Provider>;
};

export const useBooking = () => useContext(BookingContext);
